<div>
  <p class="recordsummary">{{ mwoViewData.length }} records added</p>
</div>
<div class="ButtonList">
  <div class="ButtonLeft">
    <button class="button-secondary" (click)="undoSelected()" [ngClass]="{ 'btn-disabled': selectedIds.size == 0 }">
      Undo Changes For Selection
    </button>
    <button class="button-secondary" *ngIf="selectedIds.size > 0 && isUndoClicked" (click)="redoSelected()">
      Redo
    </button>
  </div>
  <div class="ButtonRight">
    <button class="button-primary" id="clearAllInBuild" (click)="clearAll()">Clear All</button>
    <button class="button-secondary" [disabled]="!selectedIds.size" (click)="clearSelected()"
      [ngClass]="selectedIds.size ? '' : 'btn-disabled'">
      Clear Selected
    </button>
    <button id="exportMWOBuild" class="button-secondary" (click)="clickExport($event)">
      Export
    </button>
    <button class="button-secondary" (click)="clickImport($event)">Import</button>
  </div>
</div>
<div id="nonStyleGrid">
  <kendo-grid style="font-size: 10px" [data]="mwoViewData"
    class='buildGrid' [selectable]="{ enabled: true, checkboxOnly: true }"
    (selectionChange)="onSelectionChangeEvent($event)">
    <kendo-grid-checkbox-column [width]="45" [headerClass]="{ 'text-center': true }" [class]="{ 'text-center': true }"
      [resizable]="false" [columnMenu]="true" id="my-grid" [columnMenu]="false" [showSelectAll]="true"
      class="customgrid"></kendo-grid-checkbox-column>

    <kendo-grid-column field="isChanged" title="" [width]="60">
      <ng-template kendoGridCellTemplate let-dataItem let-column>
        <span *ngIf="dataItem.acdAction === 'Change'" [class.icon-disabled2]="!isUserHaveAccess"  (click)="undoById(dataItem.changeitemId)">
          <fa-icon [icon]="iconPacks.FACIRCLE" class="bluePrimary searchIcon"   [ngClass]="isUserHaveAccess?'':'icon-disabled2'" *ngIf="dataItem.acdAction === 'Change'">
          </fa-icon>
        </span>

        <span *ngIf="dataItem.acdAction === 'Add'" class="plusMinus">
          <span (click)="addNewMwo()" [class.icon-disabled2]="!isUserHaveAccess">
            <fa-icon [icon]="iconPacks.FASQUAREPLUS" class="bluePrimary plusIcon" [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
            </fa-icon>
          </span>

          <span style="margin-left: 5px" (click)="deleteNewMwo(dataItem)" [class.icon-disabled2]="!isUserHaveAccess">
            <fa-icon [icon]="iconPacks.FAMINUSSQUARE" class="bluePrimary plusIcon" [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
            </fa-icon>
          </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="ACD Action" [width]="130">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-label text="">{{ dataItem.acdAction }}</kendo-label>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="" [width]="50">
      <ng-template kendoGridCellTemplate let-dataItem>
        <fa-icon [icon]="iconPacks.FASTAR" class="plusIcon" *ngIf="!dataItem.isAddedToCR"></fa-icon>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mwoNumber" title="MWO Number" [width]="180">
    </kendo-grid-column>
    <kendo-grid-column field="equipTagNumber" title="Equip Tag Number" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction === 'Add'">
          <kendo-textbox [size]="'small'" style="width: 80%" id="{{ dataItem.changeitemId + '_equipTagNumber' }}"
            #equipTagNumberTextBox [(ngModel)]="dataItem.equipTagNumber"
            (valueChange)="onValueChange(dataItem, 'equipTagNumber', $event)" [ngClass]="{
              'backgroundChange': dataItem.acdAction === 'Add' 
              || dataItem.fieldChangedList?.includes('equipTagNumber'),
              'field-mandatory' : dataItem.errorList?.includes('equipTagNumber')
            }" (focusout)="equipTagNumberChange(dataItem)">
          </kendo-textbox>
          <span #equipTagNumber *ngIf="dataItem.acdAction == 'Add'" [class.icon-disabled2]="!isUserHaveAccess">
            <fa-icon [icon]="iconPacks.FASEARCH" [style]="'margin-left: 15px;'" [ngClass]="isUserHaveAccess?'':'icon-disabled2'" class="bluePrimary searchIcon" (click)="
                openActionPopup(
                  'equipTagNumber',
                  dataItem
                )
              "></fa-icon>
          </span>
        </div>
        <span *ngIf="dataItem.acdAction != 'Add'">
          {{ dataItem.equipTagNumber }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="mwoShortDescription" title="MWO Short Description" [width]="250">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" id="{{ dataItem.changeitemId + '_mwoShortDescription' }}" [maxlength]="30"
          [(ngModel)]="dataItem.mwoShortDescription"
          (valueChange)="onValueChange(dataItem, 'mwoShortDescription', $event)" [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('mwoShortDescription') 
          , 'field-mandatory' : dataItem.errorList?.includes('mwoShortDescription')}">
        </kendo-textbox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mwoProblemDescription" title="MWO Problem Description" [width]="250">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" (valueChange)="
            onValueChange(dataItem, 'mwoProblemDescription', $event)
          " [maxlength]="80" id="{{ dataItem.changeitemId + '_mwoProblemDescription' }}"
          [(ngModel)]="dataItem.mwoProblemDescription" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('mwoProblemDescription') 
            , 'field-mandatory' : dataItem.errorList?.includes('mwoProblemDescription')}"></kendo-textbox>
        <div class="error" [ngClass]="
            dataItem.mwoProblemDescription == '' ||
            dataItem.mwoProblemDescription.length > 80
              ? 'error'
              : ''
          ">
          <small class="disabled">Required field</small>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="jobPlanNumber" title="Job Plan Number" [width]="400">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox style="width: 90%" #jobPlanSearchTextBox
          (valueChange)="onValueChange(dataItem, 'jobPlanNumber', $event)" [size]="'small'"
          id="{{ dataItem.changeitemId + '_jobPlanNumber' }}" [(ngModel)]="dataItem.jobPlanNumber" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('jobPlanNumber')
            , 'field-mandatory' : dataItem.errorList?.includes('jobPlanNumber')}">
        </kendo-textbox>
        <span #jobPlanSearch>
          <fa-icon [icon]="iconPacks.FASEARCH" [style]="'margin-left: 15px;'" [class.icon-disabled2]="!isUserHaveAccess"  class="bluePrimary searchIcon" (click)="
              openActionPopup(
                  'jobPlanNumber',
                  dataItem
                )
            "></fa-icon>
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="areaOwnerCode" title="Area Owner Code" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-numerictextbox class="areaOwnerNumeric" style="width: 80%; align-items: center" format="#"
          [value]="dataItem.areaOwnerCode" (valueChange)="onValueChange(dataItem, 'areaOwnerCode', $event)"
          id="{{ dataItem.changeitemId + '_areaOwnerCode' }}" [(ngModel)]="dataItem.areaOwnerCode" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('areaOwnerCode')
            , 'field-mandatory' : dataItem.errorList?.includes('areaOwnerCode')}" #areaownerSearchTextbox>
        </kendo-numerictextbox>
        <span #areaownerSearch>
          <fa-icon [icon]="iconPacks.FASEARCH" [style]="'margin-left: 15px;'" class="bluePrimary searchIcon"  [class.icon-disabled2]="!isUserHaveAccess" (click)="
              openActionPopup('areaOwnerCode',dataItem)"></fa-icon>
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assignedExecutionCoordinatorCode" title="Assigned Execution Coordinator Code"
      [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-numerictextbox [value]="dataItem.assignedExecutionCoordinatorCode" style="width: 80%;align-items: center"
          (valueChange)="
            onValueChange(dataItem, 'assignedExecutionCoordinatorCode', $event)
          " format="#" id="{{ dataItem.changeitemId + '_assignedExecutionCoordinatorCode' }}"
          [(ngModel)]="dataItem.assignedExecutionCoordinatorCode" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('assignedExecutionCoordinatorCode')
            , 'field-mandatory' : dataItem.errorList?.includes('assignedExecutionCoordinatorCode')}"
          #assignedSearchTextBox>
        </kendo-numerictextbox>
        <span #assignedSearch>
          <fa-icon [icon]="iconPacks.FASEARCH" [style]="'margin-left: 15px;'" class="bluePrimary searchIcon" [class.icon-disabled2]="!isUserHaveAccess" 
            (click)="openActionPopup('assignedExecutionCoordinatorCode',dataItem)"></fa-icon></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="leadCraft" title="Lead Craft" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" style="width: 80%" #leadcraftSearchTextBox
          (valueChange)="onValueChange(dataItem, 'leadCraft', $event)" id="{{ dataItem.changeitemId + '_leadCraft' }}"
          [(ngModel)]="dataItem.leadCraft" [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('leadCraft') 
          , 'field-mandatory' : dataItem.errorList?.includes('leadCraft')}">
        </kendo-textbox>
        <span #leadcraftSearch>
          <fa-icon [icon]="iconPacks.FASEARCH" [style]="'margin-left: 15px;'" class="bluePrimary searchIcon" [class.icon-disabled2]="!isUserHaveAccess" (click)="
              openActionPopup('leadCraft',dataItem)"></fa-icon></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="woClassification" title="WO Classification" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="WoClassification" [(ngModel)]="dataItem.woClassification"
          (valueChange)="onValueChange(dataItem, 'woClassification', $event)"
          id="{{ dataItem.changeitemId + '_woClassification' }}" [(ngModel)]="dataItem.woClassification" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('woClassification')
            , 'field-mandatory' : dataItem.errorList?.includes('woClassification')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="primaryDiscipline" title="Primary Discipline" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="PrimaryDiscipline" [(ngModel)]="dataItem.primaryDiscipline"
          (valueChange)="onValueChange(dataItem, 'primaryDiscipline', $event)"
          id="{{ dataItem.changeitemId + '_primaryDiscipline' }}" [(ngModel)]="dataItem.primaryDiscipline" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('primaryDiscipline')
            , 'field-mandatory' : dataItem.errorList?.includes('primaryDiscipline')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="integrityCriticalTask" title="Integrity Critical Task" [width]="130">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="IntegralCriticalTask" [(ngModel)]="dataItem.integrityCriticalTask" (valueChange)="
            onValueChange(dataItem, 'integrityCriticalTask', $event)
          " id="{{ dataItem.changeitemId + '_integrityCriticalTask' }}" [(ngModel)]="dataItem.integrityCriticalTask"
          [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('integrityCriticalTask')
            , 'field-mandatory' : dataItem.errorList?.includes('integrityCriticalTask')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="performanceStandard" title="Performance Standard" [width]="130">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="dataItem.performanceStandardList"
          (valueChange)="onValueChange(dataItem, 'performanceStandard', $event)"
          id="{{ dataItem.changeitemId + '_performanceStandard' }}" [(ngModel)]="dataItem.performanceStandard"
          [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('performanceStandard')
            , 'field-mandatory' : dataItem.errorList?.includes('performanceStandard')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="integrityCriticalRanking" title="Integrity Critical Ranking" [width]="130"
      #integralcriticaltak>
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- <kendo-dropdownlist
            [data]="IntegralCriticalTask"
            [(ngModel)]="dataItem.integrityCriticalRanking"
            (valueChange)="
              onValueChange(dataItem, 'integrityCriticalRanking', $event)
            "
            [ngClass]="{
              backgroundChange: isEdited(dataItem, 'integrityCriticalRanking')
            }"
          ></kendo-dropdownlist> -->
        <span>{{ dataItem.asIntegrityCriticalRanking==""?'(blank)':dataItem.asIntegrityCriticalRanking }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shutdownCode" title="Shutdown Code" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="ShutdownCode" (valueChange)="onValueChange(dataItem, 'shutdownCode', $event)"
          id="{{ dataItem.changeitemId + '_shutDownCode' }}" [(ngModel)]="dataItem.shutdownCode" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('shutdownCode') || dataItem.fieldChangedList?.includes('shutDownCode')
            , 'field-mandatory' : dataItem.errorList?.includes('shutDownCode')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shutdownClassification" title="Shutdown Classification" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="ShutdownClassification" [(ngModel)]="dataItem.shutdownClassification" (valueChange)="
            onValueChange(dataItem, 'shutdownClassification', $event)
          " id="{{ dataItem.changeitemId + '_shutdownClassification' }}" [(ngModel)]="dataItem.shutdownClassification"
          [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('shutdownClassification')
            , 'field-mandatory' : dataItem.errorList?.includes('shutdownClassification')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="validateFlag" title="Validate Flag" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist [data]="validateFlag" [(ngModel)]="dataItem.validateFlag"
          (valueChange)="onValueChange(dataItem, 'validateFlag', $event)"
          id="{{ dataItem.changeitemId + '_validateFlag' }}" [(ngModel)]="dataItem.validateFlag" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('validateFlag')
            , 'field-mandatory' : dataItem.errorList?.includes('validateFlag')}"></kendo-dropdownlist>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="fileName" title="File Name" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" (valueChange)="onValueChange(dataItem, 'fileName', $event)"
          id="{{ dataItem.changeitemId + '_fileName' }}" [(ngModel)]="dataItem.fileName" [maxlength]="50" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('fileName')
            , 'field-mandatory' : dataItem.errorList?.includes('fileName')}">
        </kendo-textbox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="url" title="URLFile" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" (valueChange)="onValueChange(dataItem, 'url', $event)"
          id="{{ dataItem.changeitemId + '_url' }}" [(ngModel)]="dataItem.url" [maxlength]="254" [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('url')
            , 'field-mandatory' : dataItem.errorList?.includes('url')}">
        </kendo-textbox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="fileDescription" title="Description" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" (valueChange)="onValueChange(dataItem, 'fileDescription', $event)"
          id="{{ dataItem.changeitemId + '_fileDescription' }}" [(ngModel)]="dataItem.fileDescription" [maxlength]="148"
          [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('fileDescription')
            , 'field-mandatory' : dataItem.errorList?.includes('fileDescription')}">
        </kendo-textbox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="textattachment" title="Text Attachment" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-textbox [size]="'small'" (valueChange)="onValueChange(dataItem, 'textattachment', $event)"
          id="{{ dataItem.changeitemId + '_textattachment' }}" [(ngModel)]="dataItem.textattachment" [maxlength]="1500"
          [ngClass]="{
            'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('textattachment')
            , 'field-mandatory' : dataItem.errorList?.includes('textattachment')}">
        </kendo-textbox>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
      <div class="norecordsmwobuild">No items to show...</div>
    </ng-template>
  </kendo-grid>
</div>
<div class="errorCount">
  <app-grid-mwo-error *ngIf="mwoErrorTextList.length > 0" [setGridData]="mwoErrorTextList"></app-grid-mwo-error>
  <span class="workOrderCOunt">{{ this.mwoViewData.length }} Model Work Orders</span>
</div>

<div class="bottomButtons">
  <button class="button-back" id="backStepNavigation" (click)="backBTNClicked()">
    <a class="backLink">Back</a>
  </button>
  <button class="button-secondary btn2" (click)="saveMwoBuild()">
    Save and Add to CR
  </button>
</div>

<!-- popup for file upload -->

<app-content-popup *ngIf="showFileUploadPopup" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closePopup()">
  <ng-container>
    <app-build-import [setFieldValidationInput]="fieldValidationInput"
      (contentValidated)="imported($event)"></app-build-import>
  </ng-container>
</app-content-popup>

<app-content-popup *ngIf="popupShow" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)">
  <ng-container>
    <app-select-item-popup [setColumnConfig]="popupGridColumn" [setPlaceholder]="searchPlaceHolder"
      [setGridData]="popupDataList" (sendDataItem)="dataItemSelcted($event)"
      (pageChanged)="popupPageChanged($event)"></app-select-item-popup>
  </ng-container>
</app-content-popup>